// @flow
import { bindActionCreators} from 'redux';
import { connect } from 'react-redux';
import { actions as InTransitAction } from '../duck';
import InTransit from '../components/InTransit';

import type { RootState} from '../../../../index';

function mapStateToProps(state: RootState){
  return {
    isPostingConfirmation: state.order.purchase.inTransit.isPostingConfirmation,
    postConfirmationSuccessful: state.order.purchase.inTransit.postConfirmationSuccessful,
    postConfirmationError: state.order.purchase.inTransit.postConfirmationError,
    locale: state.locale,
    motives: state.report.motives,
  };
}

function mapDispatchToProps(dispatch: Function){
  return bindActionCreators(InTransitAction, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(InTransit);



// WEBPACK FOOTER //
// ./src/modules/order/Purchase/in-transit/containers/InTransitContainer.js